import React, { useState, useEffect } from "react";
import Icon from "../../../../../Assets/Images/help-circle.svg";
import axios from "axios";
import { Config } from "../../../../../Config";
import InfoModal from "./Modal";

const SystemMetrics = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const [Data, setData] = useState();
  const [Modal, setModal] = useState({
    isOpen: false,
    data: undefined,
  });
  const [Info] = useState({
    hitRate: translateText("ai_metrics_hitrate_text"),
    coverage: translateText("ai_metrics_coverage_text"),
    novelty: translateText("ai_metrics_novelty_text"),
    diversity: translateText("ai_metrics__textdiversity"),
  });
  const [TextToDisplay, setTextToDisplay] = useState("");

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.AuthBaseURL +
        "/api/recommendation-metrics",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let Data = {
          jpa: 0,
          candidate: 0,
          skill: 0,
        };
        Res.data.map((Item) => {
          if (Item.engineName === "jpa_recommender") {
            Data.jpa = Item;
          } else if (Item.engineName === "candidate_recommendation") {
            Data.candidate = Item;
          } else if (Item.engineName === "skill_recommender") {
            Data.skill = Item;
          }
        });
        setData(Data);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const handleModal = (SectionName, RowName) => {
    setModal({ isOpen: true, data: { section: SectionName, row: RowName } });
    if (RowName === translateText("hitrate")) {
      setTextToDisplay(Info.hitRate);
    } else if (RowName === translateText("coverage")) {
      setTextToDisplay(Info.coverage);
    } else if (RowName === translateText("novelty")) {
      setTextToDisplay(Info.novelty);
    } else {
      setTextToDisplay(Info.diversity);
    }
  };

  const handleValueAvailability = (Value) => {
    if (Value !== null && Value !== undefined) {
      return Value;
    } else {
      return translateText("n_a");
    }
  };

  return (
    <div className="main-content security-settings app-settings-form">
      <div className="user-management-form">
        {Modal.isOpen ? (
          <InfoModal
            Close={() => setModal({ isOpen: false, data: Modal.data })}
            LangData={props.LangData}
            Data={Modal.data}
            Text={TextToDisplay}
          />
        ) : null}
        <section className="form-header">
          <h1>{translateText("ai_metrics")}</h1>
        </section>
        {Data ? (
          <section className="form-body single-field-form">
            <div className="metrics-row">
              <h1>{translateText("jpa_recommendation")}</h1>
              <section className="metrics-row-item">
                <p className="metrics-row-title">{translateText("coverage")}</p>
                <input
                  disabled
                  value={handleValueAvailability(Data.jpa.coverage)}
                />
                <i
                  className="feather-info"
                  onClick={() =>
                    handleModal(
                      translateText("jpa_recommendation"),
                      translateText("coverage")
                    )
                  }
                ></i>
              </section>
              <section className="metrics-row-item">
                <p className="metrics-row-title">
                  {translateText("diversity")}
                </p>
                <input
                  disabled
                  value={handleValueAvailability(Data.jpa.diversity)}
                />
                <i
                  className="feather-info"
                  onClick={() =>
                    handleModal(
                      translateText("jpa_recommendation"),
                      translateText("diversity")
                    )
                  }
                ></i>
              </section>
            </div>
            <div className="metrics-row">
              <h1>{translateText("candidate_recommendation")}</h1>
              <section className="metrics-row-item">
                <p className="metrics-row-title">{translateText("coverage")}</p>
                <input
                  disabled
                  value={handleValueAvailability(Data.candidate.coverage)}
                />
                <i
                  className="feather-info"
                  onClick={() =>
                    handleModal(
                      translateText("candidate_recommendation"),
                      translateText("coverage")
                    )
                  }
                ></i>
              </section>
              <section className="metrics-row-item">
                <p className="metrics-row-title">{translateText("novelty")}</p>
                <input
                  disabled
                  value={handleValueAvailability(Data.candidate.novelty)}
                />
                <i
                  className="feather-info"
                  onClick={() =>
                    handleModal(
                      translateText("candidate_recommendation"),
                      translateText("novelty")
                    )
                  }
                ></i>
              </section>
              <section className="metrics-row-item">
                <p className="metrics-row-title">
                  {translateText("diversity")}
                </p>
                <input
                  disabled
                  value={handleValueAvailability(Data.candidate.diversity)}
                />
                <i
                  className="feather-info"
                  onClick={() =>
                    handleModal(
                      translateText("candidate_recommendation"),
                      translateText("diversity")
                    )
                  }
                ></i>
              </section>
            </div>
            <div className="metrics-row">
              <h1>{translateText("skill_recommendation")}</h1>
              <section className="metrics-row-item">
                <p className="metrics-row-title">{translateText("hitrate")}</p>
                <input
                  disabled
                  value={handleValueAvailability(Data.skill.hitRate)}
                />
                <i
                  className="feather-info"
                  onClick={() =>
                    handleModal(
                      translateText("skill_recommendation"),
                      translateText("hitrate")
                    )
                  }
                ></i>
              </section>
              <section className="metrics-row-item">
                <p className="metrics-row-title">{translateText("coverage")}</p>
                <input
                  disabled
                  value={handleValueAvailability(Data.skill.coverage)}
                />
                <i
                  className="feather-info"
                  onClick={() =>
                    handleModal(
                      translateText("skill_recommendation"),
                      translateText("coverage")
                    )
                  }
                ></i>
              </section>
              <section className="metrics-row-item">
                <p className="metrics-row-title">{translateText("novelty")}</p>
                <input
                  disabled
                  value={handleValueAvailability(Data.skill.novelty)}
                />
                <i
                  className="feather-info"
                  onClick={() =>
                    handleModal(
                      translateText("skill_recommendation"),
                      translateText("novelty")
                    )
                  }
                ></i>
              </section>
            </div>
          </section>
        ) : null}
      </div>
    </div>
  );
};

export default SystemMetrics;
